export default [
  {
    name: 'Dashboard',
    icon: 'ti-panel',
    path: '/tutors/dashboard'

  },
  {
    name: 'Invoices',
    icon: 'ti-bar-chart',
    path: '/tutors/invoices'
  },
  {
    name: 'Classes',
    icon: 'ti-blackboard',
    path: '/tutors/classes'
  }

]



// WEBPACK FOOTER //
// ./src/tutorLinks.js